module.exports = __webpack_public_path__ + "img/ipermitLogo.aca6ce8c.png";